import { supabase } from '../lib/supabase'

/**
 * Fetch all players the current user follows (with full player data).
 */
export async function fetchMyFollows() {
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) throw new Error('Auth session not available')

  // Get the current user's player record
  const { data: myPlayer } = await supabase
    .from('players')
    .select('id')
    .eq('user_id', user.id)
    .maybeSingle()

  if (!myPlayer) return []

  const { data, error } = await supabase
    .from('follows')
    .select('id, following_id, created_at, following:players!follows_following_id_fkey(*)')
    .eq('follower_id', myPlayer.id)
    .order('created_at', { ascending: false })

  if (error) throw error
  return data.map((f) => ({ ...f.following, follow_id: f.id }))
}

/**
 * Follow a player by their player ID.
 */
export async function followPlayer(targetPlayerId) {
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) throw new Error('Not authenticated')

  const { data: myPlayer } = await supabase
    .from('players')
    .select('id')
    .eq('user_id', user.id)
    .maybeSingle()

  if (!myPlayer) throw new Error('No player record found')

  const { data, error } = await supabase
    .from('follows')
    .insert({ follower_id: myPlayer.id, following_id: targetPlayerId })
    .select()
    .single()

  if (error) throw error
  return data
}

/**
 * Unfollow a player by their player ID.
 */
export async function unfollowPlayer(targetPlayerId) {
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) throw new Error('Not authenticated')

  const { data: myPlayer } = await supabase
    .from('players')
    .select('id')
    .eq('user_id', user.id)
    .maybeSingle()

  if (!myPlayer) throw new Error('No player record found')

  const { error } = await supabase
    .from('follows')
    .delete()
    .eq('follower_id', myPlayer.id)
    .eq('following_id', targetPlayerId)

  if (error) throw error
}

/**
 * Fetch all players who follow the current user (with full player data).
 */
export async function fetchMyFollowers() {
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) throw new Error('Auth session not available')

  const { data: myPlayer } = await supabase
    .from('players')
    .select('id')
    .eq('user_id', user.id)
    .maybeSingle()

  if (!myPlayer) return []

  const { data, error } = await supabase
    .from('follows')
    .select('id, follower_id, created_at, follower:players!follows_follower_id_fkey(*)')
    .eq('following_id', myPlayer.id)
    .order('created_at', { ascending: false })

  if (error) throw error
  return data.map((f) => ({ ...f.follower, follow_id: f.id }))
}

/**
 * Fetch recent co-players (people you've played with but don't follow).
 */
export async function fetchRecentCoPlayers() {
  const { data, error } = await supabase.rpc('get_recent_co_players')

  if (error) throw error
  return data
}
